import {
  Spinner as ChakraSpinner,
  SpinnerProps as ChakraSpinnerProps,
} from '@chakra-ui/react';

// @doc https://chakra-ui.com/docs/feedback/spinner
export type SpinnerProps = ChakraSpinnerProps;
export const Spinner = ChakraSpinner;
